"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bulkPaymentMoneyMapping = exports.individualPaymentMoneyMapping = exports.IndividualPaymentTypes = exports.BulkStatuses = exports.BulkPaymentStatus = void 0;
var BulkPaymentStatus;
(function (BulkPaymentStatus) {
    BulkPaymentStatus["PENDING"] = "pending";
    BulkPaymentStatus["SUCCESS"] = "completed";
    BulkPaymentStatus["REJECTED"] = "rejected";
    BulkPaymentStatus["DRAFT"] = "draft";
})(BulkPaymentStatus = exports.BulkPaymentStatus || (exports.BulkPaymentStatus = {}));
var BulkStatuses;
(function (BulkStatuses) {
    BulkStatuses["AWAITING_AUTH"] = "awaiting_authorization";
    BulkStatuses["INITIATION_PENDING"] = "initiation_pending";
    BulkStatuses["INITIATION_FAILED"] = "initiation_failed";
    BulkStatuses["INITIATION_COMPLETED"] = "initiation_completed";
    BulkStatuses["CANCELLED"] = "cancelled";
})(BulkStatuses = exports.BulkStatuses || (exports.BulkStatuses = {}));
var IndividualPaymentTypes;
(function (IndividualPaymentTypes) {
    IndividualPaymentTypes["INDIVIDUAL"] = "INDIVIDUAL";
    IndividualPaymentTypes["COMPANY"] = "COMPANY";
})(IndividualPaymentTypes = exports.IndividualPaymentTypes || (exports.IndividualPaymentTypes = {}));
exports.individualPaymentMoneyMapping = {
    amount: "amountScaled",
};
exports.bulkPaymentMoneyMapping = {
    amount: "amountScaled",
};
